<script setup lang="ts">
import {Models, useGraphMeta, useLocalization} from '@hantera/portal-app';
import QueryEditorNavigation from './QueryEditorNavigation.vue';
import {Query} from '@/backend/queries';
import {computed, ref} from 'vue';

const graphMeta = useGraphMeta();
const t = useLocalization();

const query = defineModel<Query>()
const selectedTab = ref('general');

const metadata = computed(() => {
  return Object.keys(graphMeta).reduce((res, node) => {
    const nodeMeta = graphMeta[node];
    if (nodeMeta) {
      res[nodeMeta.rootEdgeName] = {
        cardinality: 'many',
        node
      };
    }
    return res;
  }, {} as Record<string, Models.GraphMeta.GraphEdgeMeta>);
});

</script>

<template>

  <div v-if="query" class="query-editor">


    <div class="query-editor__margin neat-scroll">

      <QueryEditorNavigation :query="query" :navigation="query.navigation" :edges-meta="metadata" :is-main="true" v-if="selectedTab === 'general'" />

    </div>

  </div>

</template>

<style>
.query-editor__margin {
  padding: .5rem;
}
</style>